<template>
<div>
  <v-alert type="success" v-if="sent">
    <strong>{{ $t('Ihre Anfrage wurde abgeschickt, bitte überprüfen Sie Ihr E-Mail-Postfach, um diese zu bestätigen.') }}</strong>
  </v-alert>
  <template v-else>
    <v-alert type="error" v-if="error">
      <strong>{{ $t('Es ist ein Fehler aufgetreten.') }}</strong>
    </v-alert>
    <contact-form ref="contactForm"></contact-form>
    <v-card-actions class="flex-wrap" v-if="!sent">
      <v-btn color="primary" large dark @click="save" :loading="loading">{{ $t("Änderungen speichern") }}</v-btn>
      <!--
      <v-spacer></v-spacer>
      <v-btn color="error" large dark @click="onDeleteAccount">{{ $t("Konto löschen") }}</v-btn>
      -->
    </v-card-actions>
  </template>
</div>
</template>

<script>
import ContactForm from "../ContactForm";

export default {
  name: "NewsletterWizard",

  components: {
    ContactForm
  },

  data() {
    return {
      sent: false,
      error: false
    }
  },

  computed: {
    contact() {
      return this.$store.state.contact.contact;
    },

    loading() {
      return this.$store.state.loading;
    },

    newsletter() {
      if ("newsletter" in this.contact.customFields) {
        return this.contact.customFields["newsletter"];
      }

      return false;
    }
  },

  methods: {
    save() {
      const valid = this.$refs.contactForm.validate();
      if (valid) {

        this.$store.dispatch("ajax", {
          method: "post",
          url: "/v1/wizard/contact",
          data: {
            type: "newsletter",
            contact: this.$refs.contactForm.contact
          }
        }).then(() => {
          this.sent = true;
        }).catch(() => {
          this.error = true;
        });
      }
    }
  }
};
</script>

